import React, { Component, Fragment } from 'react';
import {
    Button,
    Checkbox,
    Divider,
    Form,
    Grid,
    Header,
    Icon,
    Input,
    Popup,
    Segment,
    Table,
    Message,
    Tab,
    Loader, Responsive, Label
} from 'semantic-ui-react';
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';
import { IconHeader } from '../../Assets/util/css';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';

class SemesterTransferSemesters extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            student: JSON.parse(localStorage.getItem('student')),
            filterData: JSON.parse(localStorage.getItem('filterData')),
            studentSemesters: [],
            studentSemestersForSecondStudent: [],
            checkedSemesters: [],
            activeIndex: 0,
            gradesArray: [],
            grades: {},
            newGradesArray: [],
            newGrades: {},
            newValue: null,
            checkedGrades: [],
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.transferSemesters = this.transferSemesters.bind(this);
        this.transferGrades = this.transferGrades.bind(this);
        this.fetchStudentSemesters = this.fetchStudentSemesters.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleCheckboxChangeGrades = this.handleCheckboxChangeGrades.bind(this);
        this.checkAll = this.checkAll.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.getGrade = this.getGrade.bind(this);
        this.getGradeSecond = this.getGradeSecond.bind(this);
    }

    componentDidMount() {
        let student = JSON.parse(localStorage.getItem('student'));
        this.fetchStudentSemesters(student.id);
        this.getGrade();
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value,
            // secondStudent: true
        }, () => {
            // this.setState({ newValue: value });
            if (this.state.activeIndex === 1) {
                this.getGradeSecond(value);
            } else {
                this.fetchStudentSemesters(value.id, true);
            }
        });
    }

    handleTabChange(e, { activeIndex }) {
        this.setState({
            activeIndex, filterMode: false, name: '', date: null, SPBasic: ''
        });
        localStorage.setItem('tab', activeIndex);
        if (activeIndex === 1) {
            this.getGrade();
            if (this.state.newStudyProgram) {
                this.getGradeSecond(this.state.newStudyProgram);
            }
        } else if (this.state.newStudyProgram) {
            this.fetchStudentSemesters(this.state.newStudyProgram.id, true);
        }
    }

    fetchStudentSemesters(studentStudyProgramId, secondStudent = false) {
        let student = JSON.parse(localStorage.getItem('student'));
        axios.get(`students/${studentStudyProgramId}/semesters/overview-for-admin/`)
            .then(res => {
                let studentSemesters = [];
                if (res.data.find(e => e.semester.name.name === 'ostalo') || student.gradStudentAcademicYearId) {
                    studentSemesters = [{
                        semester: {
                            academicYear: {
                                id: res.data.find(e => e.semester.name.name === 'ostalo') ?
                                    res.data.find(e => e.semester.name.name === 'ostalo').semester.academicYear.id
                                    : student.gradStudentAcademicYearId,
                                name: res.data.find(e => e.semester.name.name === 'ostalo') ?
                                    res.data.find(e => e.semester.name.name === 'ostalo').semester.academicYear.name
                                    : student.gradStudentAcademicYearName,
                            },
                            name: { name: 'Apsolventski staž' }
                        },
                        studyProgramSemester: {
                            name: ''
                        },
                        studyTypeId: null,
                        studentStatusId: null
                    }];

                    console.log('studentSemesters', studentSemesters);
                }
                if (secondStudent) {
                    this.setState({
                        checkedSemesters: [],
                        studentSemestersForSecondStudent: [...studentSemesters, ...res.data]
                    });
                } else {
                    this.setState({
                        checkedSemesters: [],
                        studentSemesters: [...studentSemesters, ...res.data]
                    });
                }
            })
            .catch(err => {
                toast('Došlo je do greške. Nije moguće dobaviti semestre.');
            });
    }

    handleCheckboxChange(id, checked) {
        if (checked) {
            this.setState({
                checkedSemesters: [...this.state.checkedSemesters, id]
            });
        } else {
            const filtered = this.state.checkedSemesters.filter(el => el !== id);
            this.setState({
                checkedSemesters: filtered,
            });
        }
    }

    handleCheckboxChangeGrades(id, checked) {
        if (checked) {
            this.setState({
                checkedGrades: [...this.state.checkedGrades, id]
            });
        } else {
            const filtered = this.state.checkedGrades.filter(el => el !== id);
            this.setState({
                checkedGrades: filtered,
            });
        }
    }


    transferSemesters() {
        this.setState({ newStudyProgramErr: false, checkedSemestersErr: false });
        let student = JSON.parse(localStorage.getItem('student'));
        let { newStudyProgram, checkedSemesters } = this.state;
        if (!newStudyProgram || checkedSemesters.length === 0) {
            if (!newStudyProgram) { toast('Niste odabrali studenta!'); this.setState({ newStudyProgramErr: true }); } else { this.setState({ newStudyProgramErr: false }); }
            if (checkedSemesters.length === 0) { toast('Niste odabrali semestre!'); this.setState({ checkedSemestersErr: true }); } else { this.setState({ checkedSemestersErr: false }); }
        } else {
            this.setState({ loader: true });

            let obj = {
                wrongStudentStudyProgramId: student.id,
                correctStudentStudyProgramId: newStudyProgram.id,
                studyProgramSemesterIds: checkedSemesters
            };
            axios.put('students/change-ssp-for-ssps', { ...obj })
                .then(res => {
                    this.setState({ loader: false });
                    toast('Uspješno ste prebacili semestre!');
                    this.fetchStudentSemesters(student.id);
                    this.fetchStudentSemesters(newStudyProgram.id, true);
                })
                .catch(err => {
                    this.setState({ loader: false });
                    if (err.response.data === 'Both ssp must be from the same spb!') {
                        toast('Prebacivanje semestara je moguće samo ako se vrši sa istog smjera.');
                    } else if (err.response.data === 'Both ssp must be for the same student!') {
                        toast('Prebacivanje semestara je moguće samo ako se vrši za istog studenta.');
                    } else if (err.response.data === 'Invalid ssps ids sent!') {
                        toast('Odabrani semestri nisu ispravni.');
                    } else if (err.response.data === 'Could not change ssp for passed semesters!') {
                        toast('Došlo je do greške! Prebacivanje semestara nije izvršeno.');
                    } else {
                        toast('Došlo je do greške! Prebacivanje semestara nije izvršeno.');
                    }
                });
        }
    }

    transferGrades() {
        this.setState({ newStudyProgramErr: false, checkedGradesErr: false });
        let student = JSON.parse(localStorage.getItem('student'));
        let { newStudyProgram, checkedGrades } = this.state;
        if (!newStudyProgram || checkedGrades.length === 0) {
            if (!newStudyProgram) { toast('Niste odabrali studenta!'); this.setState({ newStudyProgramErr: true }); } else { this.setState({ newStudyProgramErr: false }); }
            if (checkedGrades.length === 0) { toast('Niste odabrali ocjene!'); this.setState({ checkedGradesErr: true }); } else { this.setState({ checkedGradesErr: false }); }
        } else {
            this.setState({ loader: true });

            let obj = {
                wrongStudentStudyProgramId: student.id,
                correctStudentStudyProgramId: newStudyProgram.id,
                studentMarkIds: checkedGrades
            };
            axios.put('students/change-ssp-for-sci', { ...obj })
                .then(res => {
                    this.setState({ loader: false });
                    toast('Uspješno ste prebacili ocjene.!');
                    this.getGrade();
                    this.getGradeSecond(newStudyProgram);
                })
                .catch(err => {
                    this.setState({ loader: false });
                    if (err.response.data === 'Both ssp must be from the same spb!') {
                        toast('Prebacivanje ocjena je moguće samo ako se vrši sa istog smjera.');
                    } else if (err.response.data === 'Both ssp must be for the same student!') {
                        toast('Prebacivanje ocjena je moguće samo ako se vrši za istog studenta.');
                    } else if (err.response.data === 'Invalid ssps ids sent!') {
                        toast('Odabrane ocjene nisu ispravne.');
                    } else if (err.response.data === 'Could not change ssp for passed sci!') {
                        toast('Došlo je do greške! Prebacivanje ocjena nije izvršeno.');
                    } else {
                        toast('Došlo je do greške! Prebacivanje ocjena nije izvršeno.');
                    }
                });
        }
    }

    checkAll(checked) {
        this.setState({ checkAllFlag: !this.state.checkAllFlag });
        if (!checked) {
            this.setState({ checkedSemesters: [] });
        } else {
            this.setState({ checkedSemesters: this.state.studentSemesters.map((el) => el.studentStudyProgramSemesterId) });
        }
    }

    checkAllGrades(checked) {
        this.setState({ checkAllFlagGrades: !this.state.checkAllFlagGrades });
        if (!checked) {
            this.setState({ checkedGrades: [] });
        } else {
            this.setState({ checkedGrades: this.state.gradesArray.map((el) => el.id) });
        }
    }

    getGrade() {
        axios.get(`/student-exams/grades/${JSON.parse(localStorage.getItem('student')).id}`)
            .then(res => {
                const grades = res.data;
                const gradesArray = res.data.grades;
                this.setState({
                    grades,
                    gradesArray,
                    loading: false,
                    // average: grades.gradeAverage
                });
            })
            .catch(err => {
                console.log('Failed to fetch student grades');
            });
    }

    getGradeSecond(value) {
        axios.get(`/student-exams/grades/${value.el.id}`)
            .then(res => {
                const newGrades = res.data;
                const newGradesArray = res.data.grades;
                this.setState({
                    newGrades,
                    newGradesArray,
                    loading: false,
                    // average: grades.gradeAverage
                });
            })
            .catch(err => {
                console.log('Failed to fetch student grades');
            });
    }

    render() {
        let candidateDisplayName = this.state.student.firstName + ' ' + this.state.student.lastName + '  |  ' + this.state.student.studyProgramName;
        const {
            filterData, checkedSemesters, checkAllFlag, studentSemestersForSecondStudent, studentSemesters, newStudyProgram, checkAllFlagGrades, checkedGrades
        } = this.state;

        const panes = [
            {
                menuItem: 'Prebacivanje semestara',
                render: () => (<Tab.Pane as={Responsive}>
                    <Segment basic clearing>
                        {this.state.loader ?
                            <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>
                            : <Grid columns={2}>
                                <Divider vertical>
                                    <Icon name="long arrow alternate right" />
                                </Divider>
                                <Grid.Column>
                                    <Table celled selectable compact size="small">
                                        <Table.Header>
                                            <Table.Row>

                                                <Table.HeaderCell colSpan={6}>Semestar (akademska godina)</Table.HeaderCell>
                                                <Table.HeaderCell colSpan={4}>Broj semestra</Table.HeaderCell>
                                                <Table.HeaderCell width={1} verticalAlign="middle" textAlign="center" >
                                                    <Header as="h5">
                                                        <Popup
                                                            content="Označi sve"
                                                            position="top center"
                                                            trigger={
                                                                <Form>
                                                                    <Form.Field error={this.state.checkedSemestersErr}>
                                                                        <Checkbox

                                                                            checked={checkAllFlag}
                                                                            onChange={(e, { checked }) => { this.checkAll(checked); }}
                                                                        />
                                                                    </Form.Field>
                                                                </Form>
                                                            }
                                                        />
                                                        {/* <Header.Subheader>Označi sve</Header.Subheader> */}
                                                    </Header>


                                                </Table.HeaderCell>

                                            </Table.Row>
                                        </Table.Header>
                                        <Table.Body> {studentSemesters.sort((a, b) => b.semester.academicYear.id - a.semester.academicYear.id).filter(e => e.semester.name.name !== 'ostalo' && e.semester.name.name !== 'ljetna škola').map((el, index) =>
                                            (<Table.Row key={index}>


                                                <Table.Cell verticalAlign="middle" colSpan={6} >
                                                    {el.semester.name.name} ({el.semester.academicYear.name})
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle" colSpan={4}>
                                                    {el.studyProgramSemester.name}
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle" textAlign="center">
                                                    <Form>
                                                        <Form.Field error={this.state.checkedSemestersErr}>
                                                            <Checkbox
                                                                checked={checkedSemesters.filter(e => e === el.studentStudyProgramSemesterId).length !== 0}
                                                                onChange={(e, { checked }) => { this.handleCheckboxChange(el.studentStudyProgramSemesterId, checked); }}
                                                            />
                                                        </Form.Field>
                                                    </Form>

                                                </Table.Cell>
                                            </Table.Row>))}
                                        </Table.Body>
                                    </Table>
                                </Grid.Column>
                                <Grid.Column>
                                    {newStudyProgram ?
                                        studentSemestersForSecondStudent.length !== 0 ? <Table celled selectable compact >
                                            <Table.Header>
                                                <Table.Row>
                                                    <Table.HeaderCell colSpan={2}>Semestar (akademska godina)</Table.HeaderCell>
                                                    <Table.HeaderCell>Broj semestra</Table.HeaderCell>
                                                </Table.Row>
                                            </Table.Header>
                                            <Table.Body> {studentSemestersForSecondStudent.sort((a, b) => b.semester.academicYear.id - a.semester.academicYear.id).filter(e => e.semester.name.name !== 'ostalo' && e.semester.name.name !== 'ljetna škola').map((el, index) =>
                                                (<Table.Row key={index}>
                                                    <Table.Cell verticalAlign="middle" colSpan={2}>
                                                        {el.semester.name.name} ({el.semester.academicYear.name})
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle">
                                                        {el.studyProgramSemester.name}
                                                    </Table.Cell>
                                                </Table.Row>))}
                                            </Table.Body>
                                        </Table> :
                                            <p>Nema podataka.</p> :
                                        <Message negative>
                                                <p>Za prikaz semestara odaberite studenta.</p>
                                            </Message>
                                    }
                                </Grid.Column>
                            </Grid>}
                    </Segment>

                    <Segment basic clearing textAlign="center">
                        {/* <Button basic color="blue" onClick={() => { this.setState({ back: true }); }}>Odustani</Button> */}
                        <Button
                            basic
                            color="blue"
                            onClick={this.transferSemesters}
                        >Prebaci semestre</Button>
                    </Segment>
                </Tab.Pane>)
            },
            {
                menuItem: 'Prebacivanje ocjena',
                render: () => (<Tab.Pane as={Responsive}>
                    <Segment basic clearing>
                        {this.state.loader ?
                            <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>
                            : <Grid columns={2}>
                                <Divider vertical>
                                    <Icon name="long arrow alternate right" />
                                </Divider>
                                <Grid.Column>
                                    <div>
                                        {/* {this.state.loader && <Loader active inline="centered" />} */}
                                        {this.state.gradesArray.length ?
                                            <Table structured celled selectable compact size="small">
                                                <Table.Header>
                                                    <Table.Row>
                                                        <Table.HeaderCell width={1}>R. br.</Table.HeaderCell>
                                                        <Table.HeaderCell colSpan="5">Predmet</Table.HeaderCell>
                                                        <Table.HeaderCell width="1">ECTS</Table.HeaderCell>
                                                        <Table.HeaderCell colSpan={2}>
                                                            Datum ispita
                                                            <div style={{
                                                                fontSize: '0.85em',
                                                                color: '#999'
                                                            }}
                                                            >
                                                                Datum unosa ocjene
                                                            </div>
                                                        </Table.HeaderCell>
                                                        <Table.HeaderCell colSpan="2">Ocjena</Table.HeaderCell>
                                                        <Table.HeaderCell width={1} verticalAlign="middle" textAlign="center" >
                                                            <Header as="h5">
                                                                <Popup
                                                                    content="Označi sve"
                                                                    position="top center"
                                                                    trigger={
                                                                        <Form>
                                                                            <Form.Field error={this.state.checkedGradesErr}>
                                                                                <Checkbox

                                                                                    checked={checkAllFlagGrades}
                                                                                    onChange={(e, { checked }) => { this.checkAllGrades(checked); }}
                                                                                />
                                                                            </Form.Field>
                                                                        </Form>
                                                                    }
                                                                />
                                                                {/* <Header.Subheader>Označi sve</Header.Subheader> */}
                                                            </Header>


                                                        </Table.HeaderCell>
                                                    </Table.Row>
                                                </Table.Header>

                                                <Table.Body> {this.state.gradesArray.map((el, index) =>{
                                                    const isDisabled = el.mobilityGrade || el.courseEquivalence || el.examRecognition;

                                                    return (<Table.Row key={index} disabled={isDisabled}>
                                                        <Table.Cell verticalAlign="middle">
                                                            {index + 1}.
                                                        </Table.Cell>
                                                        <Table.Cell colSpan="5" verticalAlign="middle">
                                                            <Grid columns={1} centered stackable>
                                                                <Grid.Column width="12">
                                                                    {el.courseName}
                                                                </Grid.Column>
                                                                <Grid.Column width="4" verticalAlign="middle" textAlign="right">
                                                                    <span>
                                                                        {el.examRecognition &&
                                                                        <Popup
                                                                            content="Priznavanje"
                                                                            hideOnScroll
                                                                            position="top center"
                                                                            trigger={<Label size="tiny" as="a" basic><span><Icon
                                                                                name="check"
                                                                                color="blue"
                                                                            /></span></Label>}
                                                                        />}
                                                                        {el.courseEquivalence &&
                                                                        <Popup
                                                                            content="Ekvivalencija"
                                                                            hideOnScroll
                                                                            position="top center"
                                                                            trigger={<Label size="tiny" as="a" basic><span><Icon
                                                                                name="exchange"
                                                                                color="blue"
                                                                            /></span></Label>}
                                                                        />}
                                                                        {el.mobilityGrade &&
                                                                        <Popup
                                                                            content="Mobilnost"
                                                                            hideOnScroll
                                                                            position="top center"
                                                                            trigger={<Label size="tiny" as="a" basic><span><Icon
                                                                                name="sync alternate"
                                                                                color="blue"
                                                                            /></span></Label>}
                                                                        />}
                                                                    </span>
                                                                </Grid.Column>
                                                            </Grid>

                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle">
                                                            {el.ects}
                                                        </Table.Cell>
                                                        <Table.Cell colSpan="2" verticalAlign="middle">
                                                            <div>{moment(el.examDate)
                                                                .format('D. M. YYYY.')}</div>
                                                            <div style={{
                                                                fontSize: '0.85em',
                                                                color: '#999'
                                                            }}
                                                            >
                                                                {el.inputDate ? moment(el.inputDate)
                                                                    .format('D. M. YYYY.') : ''}
                                                            </div>
                                                        </Table.Cell>
                                                        <Table.Cell colSpan="2" verticalAlign="middle">
                                                            {el.mark}
                                                        </Table.Cell>
                                                        <Table.Cell verticalAlign="middle" textAlign="center">
                                                            <Form>
                                                                <Form.Field error={this.state.checkedGradesErr}>
                                                                    <Checkbox
                                                                        checked={checkedGrades.filter(e => e === el.id).length !== 0}
                                                                        onChange={(e, { checked }) => { this.handleCheckboxChangeGrades(el.id, checked); }}
                                                                    />
                                                                </Form.Field>
                                                            </Form>

                                                        </Table.Cell>

                                                    </Table.Row> );
                                                })}
                                                </Table.Body>
                                            </Table>
                                            :
                                            'Nema ocjena za traženog studenta.'
                                        }
                                    </div>
                                </Grid.Column>
                                <Grid.Column>
                                    { newStudyProgram ? this.state.newGradesArray.length ?
                                        <Table structured celled selectable compact size="small">
                                            <Table.Header>
                                                <Table.Row>
                                                    <Table.HeaderCell width={1}>R. br.</Table.HeaderCell>
                                                    <Table.HeaderCell colSpan="5">Predmet</Table.HeaderCell>
                                                    <Table.HeaderCell width="1">ECTS</Table.HeaderCell>
                                                    <Table.HeaderCell colSpan={2}>
                                                        Datum ispita
                                                        <div style={{
                                                            fontSize: '0.85em',
                                                            color: '#999'
                                                        }}
                                                        >
                                                            Datum unosa ocjene
                                                        </div>
                                                    </Table.HeaderCell>
                                                    <Table.HeaderCell colSpan="2">Ocjena</Table.HeaderCell>
                                                </Table.Row>
                                            </Table.Header>

                                            <Table.Body> {this.state.newGradesArray.map((el, index) =>
                                                (<Table.Row key={index}>
                                                    <Table.Cell verticalAlign="middle">
                                                        {index + 1}.
                                                    </Table.Cell>
                                                    <Table.Cell colSpan="5" verticalAlign="middle">
                                                        <Grid columns={1} centered stackable>
                                                            <Grid.Column width="12">
                                                                {el.courseName}
                                                            </Grid.Column>
                                                            <Grid.Column width="4" verticalAlign="middle" textAlign="right">
                                                                <span>
                                                                    {el.examRecognition &&
                                                                        <Popup
                                                                            content="Priznavanje"
                                                                            hideOnScroll
                                                                            position="top center"
                                                                            trigger={<Label size="tiny" as="a" basic><span><Icon
                                                                                name="check"
                                                                                color="blue"
                                                                            /></span></Label>}
                                                                        />}
                                                                    {el.courseEquivalence &&
                                                                        <Popup
                                                                            content="Ekvivalencija"
                                                                            hideOnScroll
                                                                            position="top center"
                                                                            trigger={<Label size="tiny" as="a" basic><span><Icon
                                                                                name="exchange"
                                                                                color="blue"
                                                                            /></span></Label>}
                                                                        />}
                                                                    {el.mobilityGrade &&
                                                                        <Popup
                                                                            content="Mobilnost"
                                                                            hideOnScroll
                                                                            position="top center"
                                                                            trigger={<Label size="tiny" as="a" basic><span><Icon
                                                                                name="sync alternate"
                                                                                color="blue"
                                                                            /></span></Label>}
                                                                        />}
                                                                </span>
                                                            </Grid.Column>
                                                        </Grid>

                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle">
                                                        {el.ects}
                                                    </Table.Cell>
                                                    <Table.Cell colSpan="2" verticalAlign="middle">
                                                        <div>{moment(el.examDate)
                                                            .format('D. M. YYYY.')}</div>
                                                        <div style={{
                                                            fontSize: '0.85em',
                                                            color: '#999'
                                                        }}
                                                        >
                                                            {el.inputDate ? moment(el.inputDate)
                                                                .format('D. M. YYYY.') : ''}
                                                        </div>
                                                    </Table.Cell>
                                                    <Table.Cell colSpan="2" verticalAlign="middle">
                                                        {el.mark}
                                                    </Table.Cell>

                                                </Table.Row>))}
                                            </Table.Body>
                                        </Table>
                                        :
                                        'Nema ocjena za traženog studenta.'
                                        :
                                        <Message negative>
                                            <p>Za prikaz ocjena odaberite studenta.</p>
                                        </Message>
                                    }
                                </Grid.Column>
                            </Grid>}
                    </Segment>

                    <Segment basic clearing textAlign="center">
                        {/* <Button basic color="blue" onClick={() => { this.setState({ back: true }); }}>Odustani</Button> */}
                        <Button
                            basic
                            color="blue"
                            onClick={this.transferGrades}
                        >Prebaci ocjene</Button>
                    </Segment>
                </Tab.Pane>)
            }
        ];
        return (
            <div>
                <h1>Prebacivanje podataka</h1>
                <div>
                    <Segment.Group raised>
                        <Segment>
                            <Header as="h3">
                                Odabir studenta
                                <Header floated="right" style={IconHeader}>
                                    <Popup
                                        floatd="right"
                                        trigger={<Icon link circular basic floated="right" name="arrow left" onClick={() => window.history.go(-1)} />}
                                        content="Vrati"
                                        hideOnScroll
                                        position="top center"
                                    />
                                </Header>
                            </Header>
                        </Segment>
                        <Segment clearing>
                            <Grid columns={2}>
                                <Divider vertical>
                                    <Icon name="long arrow alternate right" />
                                </Divider>

                                <Grid.Column>
                                    <Form>
                                        <Segment>
                                            <Form.Group widths="equal">

                                                <Form.Field required>
                                                    <label>
                                                        Student | Studijski program sa kojeg se prebacuju podaci
                                                    </label>
                                                    <input
                                                        required
                                                        fluid
                                                        disabled
                                                        placeholder="Ime i prezime studenta, studijski program"
                                                        control={Input}
                                                        name="oldStudyProgram"
                                                        value={candidateDisplayName}
                                                    />
                                                </Form.Field>
                                            </Form.Group>
                                        </Segment>
                                    </Form>
                                </Grid.Column>

                                <Grid.Column>
                                    <Form>
                                        <Segment>
                                            <Form.Group widths="equal">
                                                <Form.Field required error={this.state.newStudyProgramErr}>
                                                    <label>
                                                        Student | Studijski program na koji se prebacuju podaci
                                                    </label>
                                                    <Form.Dropdown
                                                        placeholder="Ime i prezime studenta, index, studijski program"
                                                        search
                                                        fluid
                                                        selection
                                                        options={filterData.filter(e => e.studentId === this.state.student.studentId && e.id !== this.state.student.id)}
                                                        onChange={this.handleInputChange}
                                                        value={this.state.newStudyProgram}
                                                        name="newStudyProgram"
                                                        clearable

                                                    />
                                                </Form.Field>
                                            </Form.Group>
                                        </Segment>
                                    </Form>

                                </Grid.Column>
                            </Grid>
                        </Segment>
                        <Segment><Tab id="myTab" menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} activeIndex={this.state.activeIndex} onTabChange={this.handleTabChange} /></Segment>
                    </Segment.Group>
                    <ToastContainer hideProgressBar />
                </div>
            </div>
        );
    }
}

export default SemesterTransferSemesters;



// WEBPACK FOOTER //
// ./src/views/Admin/Transfer/SemesterTransferSemesters.js